import { useCallback, useEffect, useState } from "react";
import ChoreDemo, { type DemoPhase } from "./ChoreDemo";
import { DemoContext, SiteFooter, SiteHeader } from "./Layout";
import { useRoute } from "./router";
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import Privacy from "./pages/Privacy";
import Faq from "./pages/Faq";
import "./website.css";

const PAGES = { home: Home, pricing: Pricing, privacy: Privacy, faq: Faq };

export default function Website() {
  const route = useRoute();
  const [demo, setDemo] = useState<DemoPhase | null>(null);
  const open = useCallback((phase: DemoPhase = "watch") => setDemo(phase), []);
  // The first render happens after the browser tried to scroll to the hash.
  useEffect(() => {
    if (location.hash) document.getElementById(decodeURIComponent(location.hash.slice(1)))?.scrollIntoView();
  }, []);
  const Page = PAGES[route];
  return (
    <DemoContext.Provider value={open}>
      <div className="site">
        <a className="site-skip" href="#main">
          Skip to content
        </a>
        <SiteHeader />
        <main id="main" className={"site-main page-" + route}>
          <Page />
        </main>
        <SiteFooter />
      </div>
      {demo && <ChoreDemo start={demo} close={() => setDemo(null)} />}
    </DemoContext.Provider>
  );
}
